import useSWR from 'swr';
import { getCornDiseaseControlApplications } from '/@/store/pathologies/apiProviders';

export const useGetCornDiseaseControlApplications = ({ page, pageSize = 10 }: { page?: number; pageSize?: number }) =>
    useSWR({ page, pageSize, key: 'useGetCornDiseaseControlApplications' }, getCornDiseaseControlApplications, {
        revalidateOnFocus: false,
    });
